import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import Slider1 from "../assets/Slider.jpg"
import Slider2 from "../assets/Slider-2.jpg"
import Slider3 from "../assets/Slider-3.jpg"

const Slider = () => {
  const slides = [
    { id: 1, img: Slider3, alt: "Frame 1" },
    { id: 2, img: Slider2, alt: "Frame 2" },
    { id: 3, img: Slider1, alt: "Frame 3" },
  ];

  return (
    <div className="w-full">
      <Swiper
        modules={[Navigation, Pagination, Autoplay]}
        spaceBetween={0}
        slidesPerView={1}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3000 }}
        className="w-full"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id} className="flex justify-center items-center">
              <img
                src={slide.img}
                alt={slide.alt}
                className="w-full h-auto max-h-[90vh] object-contain"
              />
            </SwiperSlide>
          ))}
          
          <style jsx>{`
            .swiper-button-next, .swiper-button-prev {
              color: #D07A1D !important; /* Change arrow color */
            }
            .swiper-pagination-bullet {
              background-color: #D07A1D !important; /* Change inactive dot color */
            }
            .swiper-pagination-bullet-active {
              background-color: #D07A1D !important; /* Change active dot color */
            }
          `}</style>
        </Swiper>

    </div>
  );
};



export default Slider;
